export enum ENotificationType {
	MENTION = 'mention',
	RECURRENCE = 'recurrence',
	SHARED_ACTION = 'shared_action',
	SHARED_OPPORTUNITY = 'shared_opportunity',
	REVOKED_OPPORTUNITY = 'revoked_opportunity',
	STATUS_UPDATE = 'status_update',
	TRASH_RETENTION_WARNING = 'trash_retention_warning',
	TRASH_RETENTION_FINAL_WARNING = 'trash_retention_final_warning',
}

export enum ENotificationReferenceType {
	OPPORTUNITY = 'opportunity',
	ACTION = 'action',
}

export interface INotificationReference {
	type: ENotificationReferenceType;
	id: string;
}

export interface INotification {
	_id: string;
	tenantId: string;
	userId: string;
	actorId: string;
	actorName: string;
	type: ENotificationType;
	title: string;
	body?: string;
	reference?: INotificationReference;
	readAt: string | null;
	archivedAt: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface INotificationListResponse {
	data: INotification[];
	total: number;
}
